import { StorageService } from './../shared/services/storage.service';
import { Component, OnInit } from '@angular/core';
import { LedgerService } from "../shared/services/ledger.service";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, QuerySnapshot, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageEntry, LogEntry, LedgerEntry, SaleEntry } from '../shared/services/ledger-entry';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.css']
})
export class SalesComponent implements OnInit {
  error: string;
  updateMode: boolean = false;
  rate: number;
  ready = false;
  taxIds = {};
  buyersTaxIds = {};

  constructor(public authService: AuthService,
    private db: AngularFirestore,
    private db2: AngularFirestore,
    private ledgerService: LedgerService,
    private storageService: StorageService) {
    //this.ledgerService.getLedger();
  }
  ngOnInit() {


    var me = this;
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    setTimeout(function () { me.getStorage(); }, 1000);// fix Latency
    this.getSale();
    // this.getStorage();
    this.setUser();
  }
  setUser() {
    this.userProfile = this.authService.getUserProfile;

    this.user = this.authService.getUser;
    this.storageEntry.user = this.userProfile.displayName;
    this.storageEntry.userEmail = this.userProfile.email;
    this.storageEntry.userNumber = this.userProfile.number;
    this.storageEntry.userId = this.user.uid;
    this.saleEntry.user = this.userProfile.displayName;
    this.saleEntry.userEmail = this.userProfile.email;
    this.saleEntry.userNumber = this.userProfile.number;
    this.saleEntry.userId = this.user.uid;
  }

  userProfile;
  user;
  order = [];
  addingNew = true;
  backup = false;
  fullView = false;
  totalCashFlow: number;
  ledger: Observable<any[]>;
  storage: Observable<any[]>;
  fileReaded: any;
  safeToFilter: boolean = true;
  totalCost = 0; totalRetail = 0; totalQ = 0; totalActualCost = 0;
  totalDebit = 0; totalCredit = 0;
  myEntry: string;
  editMode: boolean = false;
  incomeStatement = { "container": [], "directCost": [], "directCostCr": [], "sales": [], "totalSales": 0, "exp": [], "taxes": [], "zero": [], "totalZero": 0, "expOp": [], "totalExpOp": 0, "expOpCr": [], "totalExpOpCr": 0, "totalTaxes": 0, "totalExp": 0, "totalContainer": 0, "totalDirectCost": 0, "totalDirectCostCr": 0, "totalCogs": 0 };
  editType;
  entryToEdit: any = {};
  autoComplete = {
    supplier: {},
    code: {},
    storageLocation: {},
    name: {},
    buyerTaxId: {},
    buyer: {},
    buyerAddress: {},
    buyerPhone: {},
  };
  autoCompleteKeys = {
    supplier: {},
    code: {},
    storageLocation: {},
    name: {},
    buyerTaxId: {},
    buyer: {},
    buyerAddress: {},
    buyerPhone: {},
  };
  autoCompleteString = JSON.stringify(this.autoComplete); autoCompleteArray = []; codeArray = [];
  storageEntry: StorageEntry = {
    id: "",
    supplier: "",
    shipmentNumber: 0,
    code: "",
    storageLocation: "",
    name: "",
    buyer: "",
    cost: 0,
    actualCost: 0,
    retailPrice: 0,
    quantity: 0,
    log: [],
    logs: [],
    user: "",
    userId: "",
    userNumber: "",
    userEmail: "",
    url: "",
  }
  saleEntry: SaleEntry = {
    user: "",
    userEmail: "",
    userNumber: "",
    userId: "",
    date: new Date(),
    buyer: "",
    buyerTaxId: "",
    buyerPhone: "",
    buyerAddress: "",
    order: [],
    approved: false,
    approvedUser: "",
    approvedUserEmail: "",
    approvedUserNumber: "",
    approvedUserId: "",
    shipped: false,
    shippedUser: "",
    shippedUserEmail: "",
    shippedUserNumber: "",
    shippedUserId: "",
    reason: "",
    downPay: 0,
    ledgerEntrySale: [], ledgerEntryAR: [],ledgerEntryCost: []
  }
  generalStorageCollection = { generalStorage: [] };
  disabled = true;
  show = true;
  totalRetailOrder = 0; totalQOrder = 0;
  calculateOrderTotal() {
    this.totalRetailOrder = 0; this.totalQOrder = 0;
    this.saleEntry.order.forEach(elem => {
      this.totalQOrder += elem.quantity;
      this.totalRetailOrder += elem.quantity * elem.retailPrice;
    })
  }
  actualCostEdit() {
    //  console.log(this.disabled);
    // this.disabled++;
    // if (this.disabled == 2) {
    //   this.disabled = 0;
    if (confirm('Are you sure you want to enter the Stock Cost manually?')) {
      let link = document.querySelector('#autocompleteactualCost');
      if (link) {
        link.removeAttribute('disabled'); this.disabled = !this.disabled;
      }
    }
    // }
  }

  addOrderEntry(data: StorageEntry, id) {
    let entry: StorageEntry = JSON.parse(JSON.stringify(data));
    delete entry.log;
    delete entry.logs;
    entry.id = id;
    !this.saleEntry.order.includes(data) ? this.saleEntry.order.push(entry) : null;
  }
  deleteOrderEntry(entry) {
    if (confirm('Are you sure you want to delete this item?')) {

      const index = this.saleEntry.order.indexOf(entry);
      if (index > -1) {
        this.saleEntry.order.splice(index, 1);
      }
    }
  }
  addNew() {
    // if (this.addingNew) {
    //   (<HTMLInputElement>document.getElementById('addForm')).className = "col s12 m12 l12";
    //   this.addingNew = !this.addingNew;
    // } else {
    //   (<HTMLInputElement>document.getElementById('addForm')).className = "col s12 m12 l10";
    //   this.addingNew = !this.addingNew;

    // }
  }
  showBackup() {
    this.backup = !this.backup;
  }
  getFullView() {
    this.fullView = !this.fullView;
  }

  roundValue(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;

  }
  getSale() {
    // console.log("calling server for ledger");
    // 
    this.storage = this.db.collection("generalSale")
      .snapshotChanges()
      .pipe(
        map(
          actions => {
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as SaleEntry;
              const id = a.payload.doc.id;
              //console.log(data);
              this.addAutoComplete(data);
              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              return { id, data };
            });
          }));
  }
  getStorage() {

    this.storage = this.db2.collection("generalStorage", ref => ref.orderBy("storageLocation"))
      .snapshotChanges()
      .pipe(
        map(
          actions => {
            this.ready = true;
            this.totalCost = 0; this.totalRetail = 0; this.totalQ = 0; this.totalActualCost = 0;
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as StorageEntry;
              const id = a.payload.doc.id;
              //console.log(data);
              this.totalCost += data.cost; this.totalRetail += data.retailPrice; this.totalQ += data.quantity;
              this.totalActualCost += data.actualCost;
              this.addAutoComplete(data);
              this.generalStorageCollection.generalStorage.push(data);
              this.show = true;
              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              return { id, data };
            });
          }));


  }
  calculateCost(storageEntry: StorageEntry) {
    // get storage shipment and number then get rate .. get cogs then get provisional tax from income statement .. rate = ((cost*rate)*(cogs+tax)/(cogs)), rate*cost
    let shipmentNumber = storageEntry.shipmentNumber;
    let supplier = storageEntry.supplier;

    //console.log("filterstart");
    let db = this.db;//handle case zero ? ask dad ?
    //get container
    let collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Container"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["container"] = [];
        this.incomeStatement["totalContainer"] = 0;
        this.incomeStatement["totalCogs"] = 0;
        querySnapshot.forEach((doc: any) => {
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["container"].push(data);
          this.incomeStatement["totalContainer"] -= data["debitValue"];
          this.incomeStatement["totalCogs"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        })
      });
    //get direct cost
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Direct Cost"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["directCost"] = [];
        this.incomeStatement["totalDirectCost"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["directCost"].push(data);
          this.incomeStatement["totalDirectCost"] -= data["debitValue"];
          this.incomeStatement["totalCogs"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get direct cost Cr
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', "Direct Cost"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["directCostCr"] = [];
        this.incomeStatement["totalDirectCostCr"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["directCostCr"].push(data);
          this.incomeStatement["totalDirectCostCr"] += this.roundValue(data["debitValue"]);
          this.incomeStatement["totalCogs"] += this.roundValue(data["debitValue"]);
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });





    //get Exp
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Exp"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["exp"] = [];
        this.incomeStatement["totalExp"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["exp"].push(data);
          this.incomeStatement["totalExp"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get provisional tax
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "provisional tax"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["taxes"] = [];
        this.incomeStatement["totalTaxes"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["taxes"].push(data);
          this.incomeStatement["totalTaxes"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get Sales
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', "Sales"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["sales"] = [];
        this.incomeStatement["totalSales"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["sales"].push(data);
          this.incomeStatement["totalSales"] += this.roundValue(data["debitValue"]);
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    let rate = 0;
    collection = db.collection("generalShipments", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data();
          //Get document id
          const id = doc.id;
          //  console.log(data.rate);
          data.rate ? rate = data.rate : null;
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    var me = this;
    setTimeout(function () {
      me.rate = ((storageEntry.cost * rate) * (me.incomeStatement.totalCogs + (-1 * me.incomeStatement.totalTaxes)) / (me.incomeStatement.totalCogs))
      me.storageEntry.actualCost <= me.storageEntry.cost * me.rate ? me.storageEntry.actualCost = me.storageEntry.cost * me.rate : null;// handle rate not found set to zero
      //  console.log(storageEntry.cost, rate, me.incomeStatement.totalCogs, (-1 * me.incomeStatement.totalTaxes), me.incomeStatement.totalCogs);
    }, 500);
  }
  isToday(dateParameter) {
    var today = new Date();
    //  console.log("is today?", dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear());

    return dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear();
  }
  getArrayOfKeysFromObject(obj) {
    var arr = [];
    Object.keys(obj).forEach(function (key) {
      //var value = data[key];
      arr.push(key);
    });
    return arr;
  }
  addAutoComplete(data) {
    // 
    var me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];
      if (me.autoComplete[key][data[key]] != "" && data[key] != "" && data[key]) {
        me.autoComplete[key][data[key]] = "";
        me.autoCompleteArray.push(data[key]);
        key == "buyerTaxId" ? me.taxIds[data.buyerTaxId] = { buyer: data.buyer, buyerTaxId: data.buyerTaxId, phone:data.buyerPhone, address:data.buyerAddress } : null;
        key == "buyer" ? me.buyersTaxIds[data.buyer] = { buyer: data.buyer,buyerTaxId: data.buyerTaxId, phone: data.buyerPhone, address: data.buyerAddress } : null;

      }
    // TODO on log update dont set buyer
    });
    me.autoCompleteString = JSON.stringify(me.autoComplete);
    //console.log(this.autoComplete);
  }
  updateValueOnAutocomplete() {
    let me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      let val = (<HTMLInputElement>document.getElementById('autocomplete' + key)).value;
      if (val) {
        if (key != 'shipmentNumber') {
          if (key == 'date') {
            me.saleEntry[key] = new Date(val);
          }
          else
            me.saleEntry[key] = val;
        }
        else {
          me.saleEntry[key] = Number.parseFloat(val);
        }
        if (key == "buyerTaxId" && me.taxIds[val]) {
          me.saleEntry.buyer = me.taxIds[val].buyer;
          me.saleEntry.buyerTaxId = me.taxIds[val].buyerTaxId;
          me.saleEntry.buyerPhone = me.taxIds[val].phone;
          me.saleEntry.buyerAddress = me.taxIds[val].address;

        }
        if (key == "buyer" && me.buyersTaxIds[val]) {
          me.saleEntry.buyer = me.buyersTaxIds[val].buyer;
          me.saleEntry.buyerTaxId = me.buyersTaxIds[val].buyerTaxId;
          me.saleEntry.buyerPhone = me.buyersTaxIds[val].phone;
          me.saleEntry.buyerAddress = me.buyersTaxIds[val].address;
        }
        
        //console.log(me.LedgerEntry[key]);
      }
      //
    });
  }
  // getRecordToUpdate(code) {

  // }
  clear() {
    this.saleEntry.buyerTaxId = "";
    this.saleEntry.buyer = "";
    this.saleEntry.buyerPhone = "";
    this.saleEntry.buyerAddress = "";
  }
  filterLedgerFromServerByText(): void {
    this.updateValueOnAutocomplete();
    //  console.log("filter called");
    let keys = Object.keys(this.autoComplete.code);
    // keys.length != this.codeArray.length ? this.codeArray = keys : null;
    keys.includes(this.storageEntry.code) ? this.updateMode = true : this.updateMode = false;
    // this.updateMode ? this.getRecordToUpdate(this.storageEntry.code) : null;
    // enter edit mode
    let supplier = this.storageEntry.supplier;
    let shipmentNumber = this.storageEntry.shipmentNumber;
    let code = this.storageEntry.code;
    let name = this.storageEntry.name;
    let storageLocation = this.storageEntry.storageLocation;

    //  console.log("filter", supplier, shipmentNumber, code, name, storageLocation);
    if (supplier == "" && this.safeToFilter) {
      this.getStorage();
      if ((this.autoCompleteArray.includes(code) ||
        this.autoCompleteArray.includes(name) ||
        this.autoCompleteArray.includes(storageLocation)) &&
        this.safeToFilter) {
        //console.log("filterstart");
        let db = this.db;//handle case zero ? ask dad ?
        let collection = db.collection("generalStorage");
        if (code != "") {
          code == '0' ?
            collection = db.collection("generalStorage", ref => ref.where('cost', '==', 0)) :
            collection = db.collection("generalStorage", ref => ref.where('code', '==', code));
        }
        if (name != "") {
          collection = db.collection("generalStorage", ref => ref.where('name', '==', name))
        }
        if (storageLocation != "") {
          collection = db.collection("generalStorage", ref => ref.where('storageLocation', '==', storageLocation))
        }
        if (storageLocation != "" && name != "") {
          collection = db.collection("generalStorage", ref => ref.where('storageLocation', '==', storageLocation).where('name', '==', name))
        }
        if (storageLocation != "" && name != "" && code != "") {
          collection = db.collection("generalStorage", ref => ref.where('storageLocation', '==', storageLocation).where('name', '==', name).where('code', '==', code))
        }
        if (name != "" && code != "") {
          collection = db.collection("generalStorage", ref => ref.where('storageLocation', '==', storageLocation).where('name', '==', name).where('code', '==', code))
        }

        this.storage = collection.snapshotChanges().pipe(
          map(
            actions => {
              this.totalCost = 0; this.totalRetail = 0; this.totalQ = 0;
              return actions.map(a => {
                //Get document data
                const data = a.payload.doc.data() as StorageEntry;
                const id = a.payload.doc.id;
                this.updateMode ? this.editEntry(data, id) : null;
                this.totalCost += data.cost; this.totalRetail += data.retailPrice; this.totalQ += data.quantity;
                //console.log(data);
                //this.addAutoComplete(data)
                // this.generalLedgerCollection.generalLedger.push(data);
                // let unix_timestamp = data.date['seconds']
                // var date = new Date(unix_timestamp * 1000); //console.log(date);
                // Math.abs(2 % 2) == 1
                //Use spread operator to add the id to the document data
                return { id, data };
              });
            }));
      }
      return;
    } //console.log("filter check", this.autoCompleteArray.includes(supplier) && this.safeToFilter, this.autoCompleteArray , supplier, this.safeToFilter);
    if (this.autoCompleteArray.includes(supplier) && this.safeToFilter) {
      //console.log("filterstart");
      let db = this.db;//handle case zero ? ask dad ?
      let collection = db.collection("generalStorage");
      if (shipmentNumber == 0) {
        collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier))
      }
      else {
        collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber));
        if (code != "") {

          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('code', '==', code))
        }
        if (code != "" && name != "") {

          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('code', '==', code).where('name', '==', name))
        }
        if (code != "" && storageLocation != "") {

          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('code', '==', code).where('storageLocation', '==', storageLocation))
        }
        if (code != "" && name != "" && storageLocation != "") {

          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('code', '==', code).where('name', '==', name).where('storageLocation', '==', storageLocation))
        }
        if (name != "") {
          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('name', '==', name))
        }
        if (storageLocation != "") {
          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('storageLocation', '==', storageLocation))
        }
        if (name != "" && storageLocation != "") {
          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('name', '==', name).where('storageLocation', '==', storageLocation))
        }


      }

      this.storage = collection.snapshotChanges().pipe(
        map(
          actions => {
            this.totalCost = 0; this.totalRetail = 0; this.totalQ = 0;
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as StorageEntry;
              const id = a.payload.doc.id;
              this.updateMode ? this.editEntry(data, id) : null;
              this.totalCost += data.cost; this.totalRetail += data.retailPrice; this.totalQ += data.quantity;
              //console.log(data);
              //this.addAutoComplete(data)
              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              return { id, data };
            });
          }));
    }


  }
  editEntry(ledgerEntry, id) {
    //  console.log(ledgerEntry, id);
    //Set taskToEdit and editMode
    this.storageEntry = JSON.parse(JSON.stringify(ledgerEntry));
    window.scrollTo(0, 0);
    this.setUser();
    this.editMode = true;
    this.updateMode = true;
    this.editType = "";
    this.entryToEdit.id = id;
    this.entryToEdit.data = JSON.parse(JSON.stringify(ledgerEntry));
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    //Set form value
    //this.myEntry = ledgerEntry.description;
  } //edit
  handleEdit() {
    //  console.log(this.editType, this.entryToEdit.data);
    switch (this.editType) {
      case "edit":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        break;
      case "sale":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.quantity = 0;
        break;
      case "return":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.quantity = 0;
        break;
      case "new":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.shipmentNumber = 0;
        break;
      default:
        // code block
        break
    }
  }
  saveEntry() {
    this.setUser();
    this.storageService.addSale(this.saleEntry);
    //balance values

    //set edit mode to false and clear form
    this.updateMode = false;
    this.editMode = false;
    this.editType = "";
    this.entryToEdit = {};
    this.saleEntry = {
      user: "",
      userEmail: "",
      userNumber: "",
      userId: "",
      date: new Date(),
      buyer: "",
      buyerTaxId: "",
      buyerPhone: "",
      buyerAddress: "",
      order: [],
      approved: false,
      approvedUser: "",
      approvedUserEmail: "",
      approvedUserNumber: "",
      approvedUserId: "",
      shipped: false,
      shippedUser: "",
      shippedUserEmail: "",
      shippedUserNumber: "",
      shippedUserId: "",
      reason: "",
      downPay:0,
      ledgerEntrySale: [],ledgerEntryAR:[],ledgerEntryCost: []
    }
    this.setUser();
    // this.getStorage();
    this.myEntry = "";

  } //saveTask
  deleteTask(entry) {
    if (confirm('Are you sure you want to delete this item?')) {
      //Get the entry id
      let taskId = entry.id;
      // this.totalActualCost -= entry.data.actualCost;
      //delete the entry
      this.storageService.deleteStorageTask(taskId, entry.data.log);
    }
  } //deleteTask
  exportJSON() {
    var a = document.createElement("a");
    var file = new Blob([JSON.stringify(this.generalStorageCollection)], { type: 'application/json' });
    a.href = URL.createObjectURL(file);
    a.download = 'backup.json';
    a.click();
    //https://firebase.google.com/docs/firestore/manage-data/export-import
    //console.log("https://firebase.google.com/docs/firestore/manage-data/export-import");
  }
  importJSON(csv: any) {
    this.safeToFilter = false;
    this.fileReaded = csv.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);
    //console.log(reader.result)
    reader.onload = (e) => {

      let result = reader.result.toString();
      let json = JSON.parse(result);
      //console.log(json)
      for (let i = 0; i < json["generalStorage"].length; i++) {

        this.storageEntry = json["generalStorage"][i];
        // Object.keys(json["generalStorage"]).forEach(function (key) {

        //   this.StorageEntry[key] = json["generalStorage"][i][key];
        // });
        //console.log(this.StorageEntry)
        this.saveEntry();
        this.storageEntry = {
          id: "",
          supplier: "",
          shipmentNumber: 0,
          code: "",
          storageLocation: "",
          name: "",
          buyer: "",
          cost: 0,
          actualCost: 0,
          retailPrice: 0,
          quantity: 0,
          log: [],
          logs: [],
          user: "",
          userId: "",
          userNumber: "",
          userEmail: "",
          url:"",
        }
        this.safeToFilter = true;
      }
    }
  }
}
